import { motion } from "framer-motion";
import { Check } from "lucide-react";

const RECAP_VIDEO =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/380d5a3bd7e52c72_d6989d3a6563465b9adf2306ceed4879.mov";

export default function FallLeague() {
  return (
    <div data-testid="fall-league-page" className="pt-28 md:pt-32">
      <section data-testid="fall-league-recap" className="pb-20 md:pb-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <div className="bg-primary text-primary-foreground p-6 md:p-8 flex items-center gap-5 flex-wrap">
              <Check size={44} strokeWidth={2.5} className="shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-primary-foreground/80 mb-2">Wrapped</div>
                <h1 data-testid="fall-league-recap-title" className="font-display uppercase text-3xl md:text-5xl leading-[0.95] tracking-tight">
                  Fall League: <span className="underline decoration-[3px] underline-offset-[6px]">completed.</span>
                </h1>
                <p className="mt-3 text-sm md:text-base text-primary-foreground/90 max-w-3xl">
                  A huge thank you to every player, family, and coach that made this day special. Here's a quick look at our Fall League 2026.
                </p>
              </div>
            </div>

            <div className="relative mt-4 md:mt-5 bg-foreground overflow-hidden border border-foreground/15" data-testid="fall-league-recap-video">
              <video
                className="w-full h-auto block"
                playsInline
                preload="metadata"
                controls
              >
                <source src={RECAP_VIDEO} type="video/mp4" />
              </video>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
